import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { Response } from 'services/api/types'

type AutentiqueLink = {
  link: string
}

const createFutureDelivery = (data: any): Response<AutentiqueLink> => {
  return axios.post(`/orders/${data.orderId}/future-delivery`, data)
}

export function useCreateFutureDelivery() {
  const queryClient = useQueryClient()
  return useMutation(createFutureDelivery, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('loadFutureDelivery')
      queryClient.invalidateQueries('orderActions')
      queryClient.invalidateQueries(`loadRequiredExpeditionUnities`)
      toast.success('Remessa de entrega futura criada com sucesso!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível criar a entrega futura!')
    }
  })
}
